import { render, staticRenderFns } from "./InputAmount.vue?vue&type=template&id=71eb8a1a&scoped=true"
import script from "./InputAmount.vue?vue&type=script&lang=js"
export * from "./InputAmount.vue?vue&type=script&lang=js"
import style0 from "./InputAmount.vue?vue&type=style&index=0&id=71eb8a1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71eb8a1a",
  null
  
)

export default component.exports